export default class Constants {
  public static readonly urlTempIdParam: string = 'tempId';
  public static readonly urlHashParam: string = 'hash';
  public static readonly appLink: string = 'https://kimgbister.go.link/?adjustId=80263&adj_t=1ikgxu52';
  public static readonly closeLink: string = 'https://kazandirio.go.link/i4UxA';

}
